import { Avatar, Box, Button, Chip, Divider, Grid, Rating, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import Image from "next/image";
import { ImgUrl, isProduction } from '@/config';
import { SwiperSlide } from "swiper/react";

import CardProfile from "@/components/cards/store-profile";
import ProductInfo from "@/components/store/product-info";
import CardAddCard from "./cardAddcart"
import axios from 'axios';
import Link from "@mui/material/Link";
import Cookies from 'universal-cookie';
import ReportForm from '../utilities/reportForm';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import FavoriteButton from "@/components/utilities/FavoriteButton";
import { blue } from "@mui/material/colors";
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import duration from 'dayjs/plugin/duration';
import { useRouter } from 'next/router';
import CountDownTime from "../campaign/countdownTime";
import FlashOnIcon from '@mui/icons-material/FlashOn';
import { VideoJsonLd } from 'next-seo';
import DialogCheckDateService from '../dialog/DialogCheckDateService';

dayjs.extend(duration);

interface ProductItem {
    item_id: string;
    item_name: string;
    affiliation: string | null;
    coupon: string | null;
    discount: number;
    index: number;
    item_brand: string | null;
    item_category: string | null;
    item_category2: string | null;
    item_category3: string | null;
    item_category4: string | null;
    item_category5: string | null;
    item_list_id: string;
    item_list_name: string;
    item_variant: string | null;
    location_id: string | null;
    price: number;
    quantity: number;
}

dayjs.locale('th');
dayjs.extend(localizedFormat);
dayjs.extend(buddhistEra);

export default function ProductDetail({ dataProduct, campaign, dataStoreInfo, data_info, productType, dataWaranty, dataProductDetail, dataProductSpecific, getToken, dataCampaigncomingsoon }: any) {


    const cookies = new Cookies();
    const authToken = cookies.get("token");
    const token = getToken
    const router = useRouter();
    const product = dataProduct?.products;
    const [isScrolledCard, setIsScrolledcard] = useState(false);
    const currentUrl = typeof window !== "undefined" ? window.location.href : "";
    const [selectedIndex, setSelectedIndex] = useState(0);
    const videoRef: any = useRef(null);
    const [priceProduct, setPriceProduct] = useState<number>(0);
    const [discountPrice, setDiscountPrice] = useState<number>(0);
    const [optionStork, setOptionStork] = useState<number>(0);
    const [productIdOption, setProductIdOption] = useState([]);
    const [optionChildValue, setOptionChildValue] = useState<[] | null>([]);
    const [productOption, setOption] = useState<number | null>(null);
    const [optionChild, setOptionChild] = useState<number | null>(null);
    const { product_option = [] } = dataProduct?.products ?? {};
    const [maxPrice, setMaxPrice] = useState<any>();
    const [priceRange, setPriceRange] = useState('');
    const [items, setItems] = useState<ProductItem[]>([]);
    const itemList = {
        itemListId: "related_products",
        itemListName: "สินค้า/บริการ ที่เกี่ยวข้อง",
    };

    const campaignComingSoonDateTime: string = dataProduct?.products?.product_in_campaign_coming_soon?.campaign_product_join?.campaign_start ?? '';

    useEffect(() => {
        setPriceRange(findPriceRange(dataProduct));
        setMaxPrice(findPriceMax(dataProduct));
        calDisplayPrice(undefined);
    }, []);

    const handleClickImage = (index: number) => {
        setSelectedIndex(index);
        if (videoRef.current) {
            videoRef.current.muted = true;
            videoRef.current.pause();
        }
    };

    const mixedArray = [];

    if (product?.product_vdo) {
        mixedArray.push({ video_url: product.product_vdo });
    }

    product?.product_image?.forEach((image: any) => {
        mixedArray.push({ image_url: image.image_url });
    });


    const firstOptionTitle =
        dataProduct?.products?.product_option?.[0]?.option_title;

    const firstOptionChildTitle =
        dataProduct?.products?.product_option?.[0]?.option_child[0]?.option_title;

    useEffect(() => {
        const filteredData = product_option?.filter(
            (item: any) => item.option_id === productIdOption
        );

        if (filteredData[0]?.option_child.length !== 0) {
            setOptionChildValue(filteredData[0]?.option_child);
        } else {
            setOptionChild(0);
        }
    }, [productIdOption, product_option]);

    useEffect(() => {
        if (product_option.length !== 0) {
            setProductIdOption(product_option[0].option_id);
        }
        setPriceProduct(dataProduct?.products.product_normal_price);
        setDiscountPrice(dataProduct?.products.product_discounted_price);
        setOptionStork(dataProduct?.products.product_stock);

        // console.log(JSON.stringify(dataProduct,null,2))
    }, [dataProduct]);

    const findPriceMax = (dataProduct: any) => {
        let prices: number[] = [];

        if (dataProduct?.products?.product_option?.[0]?.option_child.length === 0) {
            dataProduct?.products?.product_option?.forEach((option: any) => {
                if (option.option_discount != null && option.option_price != null) {
                    prices.push(option.option_price);
                }
            })
        } else {
            dataProduct?.products?.product_option?.forEach((option: any) => {
                option.option_child.forEach((child: { option_price: number | null }) => {
                    if (child.option_price != null) {
                        prices.push(child.option_price);
                    }
                })
            })
        }

        const filteredPrices = prices.filter((price: number) => price > 0);
        if (filteredPrices.length === 0) {
            return "";
        }
        const minPrice = Math.min(...filteredPrices);
        const maxPrice = Math.max(...filteredPrices);
        if (minPrice === maxPrice) {
            return `฿${formatNumber(minPrice)}`;
        }
        return `฿${formatNumber(minPrice)} - ${formatNumber(maxPrice)}`;
    }

    const findPriceRange = (dataProduct: any) => {
        let prices: number[] = [];

        if (dataProduct?.products?.product_option?.[0]?.option_child.length === 0) {
            dataProduct?.products?.product_option?.forEach((option: any) => {
                if (option.option_discount !== null && option.option_price !== null) {
                    prices.push(option.option_discount > 0 ? option.option_discount : option.option_price);
                }
            });
        } else {
            dataProduct?.products?.product_option?.forEach((option: any) => {
                option.option_child.forEach((child: { option_discount: number | null, option_price: number | null }) => {
                    if (child.option_discount !== null && child.option_price !== null) {
                        prices.push(child.option_discount > 0 ? child.option_discount : child.option_price);
                    }
                });
            });
        }

        const filteredPrices = prices.filter((price: number) => price > 0);

        if (filteredPrices.length === 0) {
            return "";
        }

        const minPrice = Math.min(...filteredPrices);
        const maxPrice = Math.max(...filteredPrices);

        // Check if min and max are equal
        if (minPrice === maxPrice) {
            return `${formatNumber(minPrice)}`; // Return only the minimum price
        }

        return `${formatNumber(minPrice)} - ${formatNumber(maxPrice)}`;
    };

    const [fullPrice, setFullPrice] = useState('');

    const calDisplayPrice = (newAlignment: number | undefined) => {
        const findOptionById = (options: any, id: number | undefined): any => {
            if (!Array.isArray(options)) {
                return undefined; // Safeguard: return undefined if options is not an array
            }

            for (const option of options) {
                if (option.option_id === id) return option;
                if (option.option_child) {
                    const found = findOptionById(option.option_child, id);
                    if (found) return found;
                }
            }
            return undefined;
        };

        const findOptionPrices = (options: any[]): number[] => {
            const prices: number[] = [];
            const traverseOptions = (optionsList: any[]) => {
                for (const option of optionsList) {
                    prices.push(option.option_price);
                    if (option.option_child) traverseOptions(option.option_child);
                }
            };
            traverseOptions(options);
            return prices;
        };

        const findDisPrices = (options: any[]): number[] => {
            const disPrices: number[] = [];
            const traverseOptions = (optionsList: any[]) => {
                for (const option of optionsList) {
                    disPrices.push(option.option_discount);
                    if (option.option_child) traverseOptions(option.option_child);
                }
            };
            traverseOptions(options);
            return disPrices;
        };

        const selectedOption = findOptionById(dataProduct.products.product_option, newAlignment);

        if (selectedOption) {
            // Display price for the selected option
            if (selectedOption.option_discount === selectedOption.option_price || selectedOption.option_discount === 0) {
                setFullPrice(""); // Hide price if fully discounted or no discount
            } else {
                setFullPrice(`฿${formatNumber(selectedOption.option_price)}`);
            }
        } else {
            // No specific option selected; check overall product discount
            if (dataProduct?.products?.product_discounted_price === 0) {
                // Filter prices above zero
                const optionPrices = findOptionPrices(dataProduct.products.product_option).filter(price => price > 0);
                const optionDisPrices = findDisPrices(dataProduct.products.product_option).filter(disPrices => disPrices > 0)

                if (optionPrices.length > 0) {
                    const minPrice = Math.min(...optionPrices);
                    const maxPrice = Math.max(...optionPrices);

                    if (optionDisPrices.length === 0) {
                        // If no discounted prices are available, show nothing
                        setFullPrice("");
                    } else {
                        const minDisPrice = Math.min(...optionDisPrices);
                        const maxDisPrice = Math.max(...optionDisPrices);

                        if (minPrice === maxPrice) {
                            // If all option prices are the same, show only the single price
                            setFullPrice(`฿${formatNumber(minPrice)}`);
                        } else if (minDisPrice === maxDisPrice) {
                            // If all discounted prices are the same, show nothing
                            setFullPrice("");
                        } else {
                            // Otherwise, show a price range
                            setFullPrice(`฿${formatNumber(minPrice)} - ฿${formatNumber(maxPrice)}`);
                        }
                    }
                } else {
                    setFullPrice("");
                }
            } else {
                setFullPrice(`${findPriceMax(dataProduct)}`);
            }
        }

        // Additional handling when there are no product options
        const maxOptionPrice = Math.max(
            ...((dataProduct?.products?.product_option || []).map((option: { option_price: any; }) => option.option_price || 0))
        );

        if (dataProduct?.products?.product_option?.length === 0) {
            if (dataProduct.products.product_normal_price > 0) {
                setFullPrice(
                    dataProduct.products.product_discounted_price === 0
                        ? ""
                        : `฿${formatNumber(dataProduct.products.product_normal_price)}`
                );
            } else if (dataProduct.products.product_discounted_price !== 0) {
                setFullPrice(`฿${formatNumber(maxOptionPrice)}`);
            }
        }
    };

    const handleChangeOption = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: number | any
    ) => {
        if (optionChild == 0) {
            if (newAlignment == null) {
                setMaxPrice(findPriceMax(dataProduct));
                setPriceProduct(dataProduct?.products.product_normal_price);
                setDiscountPrice(dataProduct?.products.product_discounted_price);
                setOptionStork(dataProduct?.products.product_stock);
                setOption(null);
                calDisplayPrice(undefined)
            } else {
                calDisplayPrice(newAlignment)
                setOption(newAlignment);
                setProductIdOption(newAlignment);
            }
        } else {
            if (newAlignment == null) {
                calDisplayPrice(undefined)
                setPriceProduct(dataProduct?.products.product_normal_price);
                setDiscountPrice(dataProduct?.products.product_discounted_price);
                setOptionStork(dataProduct?.products.product_stock);
                setOption(null);
                setOptionChild(null);
            } else {
                calDisplayPrice(undefined)
                setOptionChild(null);
                setOption(newAlignment);
                setProductIdOption(newAlignment);
            }
        }

        for (let option of product_option) {
            if (option.option_id == newAlignment) {
                if (option.option_child.length > 0) {
                    let selectedOption;
                    for (const optionLoop of option.option_child) {
                        if (optionLoop.option_stock === 0) {
                            selectedOption = optionLoop;
                        } else {
                            selectedOption = optionLoop;
                            break;
                        }
                    }
                    if (!selectedOption) {
                        selectedOption = option.option_child[0];
                    }
                    setPriceProduct(selectedOption.option_discount > 0 ? selectedOption.option_discount : selectedOption.option_price);
                    setOptionStork(selectedOption.option_stock);

                } else {
                    setMaxPrice(option.option_price);
                    setPriceProduct(option.option_discount > 0 ? option.option_discount : option.option_price);
                    setDiscountPrice(option.option_discount);
                    setOptionStork(option.option_stock);
                    updateDataLayer(option, itemList);
                }
            }
        }
    };

    const handleChangeOptionChild = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: number | undefined
    ) => {
        calDisplayPrice(newAlignment)
        if (newAlignment == null) {
            setMaxPrice(findPriceMax(dataProduct));
            setOptionChild(null);
            setOptionStork(dataProduct?.products.product_stock);
            setPriceProduct(dataProduct?.products.product_normal_price);
            setDiscountPrice(dataProduct?.products.product_discounted_price);
            calDisplayPrice(undefined)
        } else {
            calDisplayPrice(newAlignment)
            setOptionChild(newAlignment);
        }

        for (const option of product_option) {
            const foundChild = option.option_child.find(
                (child: { option_id: number }) => child.option_id === newAlignment
            );
            if (foundChild) {
                setMaxPrice(foundChild.option_price);
                setPriceProduct(foundChild.option_discount > 0 ? foundChild.option_discount : foundChild.option_price);
                setDiscountPrice(foundChild.option_discount);
                setOptionStork(foundChild.option_stock);
                const productItem = {
                    ...option,
                    option_child: [foundChild],
                };
                updateDataLayer(productItem, itemList);
                break;
            }
        }
    };

    function isEmpty(object: any) {
        for (const property in object) {
            return false;
        }
        return true;
    }

    const formatNumber = (number: any) => {
        if (number === null || number === undefined) return '';
        return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolledcard(true);
            } else {
                setIsScrolledcard(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const renderSliderItem = (item: any) => {
        if (item?.image_url) {
            return (
                <SwiperSlide key={item?.sort} style={{ textAlign: "center" }}>
                    <Box
                        sx={{
                            position: "relative",
                            textAlign: "center"

                        }}>
                        <Box
                            display={dataProduct.products.product_stock == "0" ? "inline-block" : "none"}
                            sx={{

                                zIndex: 99,
                                backgroundColor: "rgba(0, 0, 0, 0.4)",

                                borderRadius: "12px",
                                maxHeight: "400px",

                                maxWidth: "100%",
                                height: "100%",
                            }}
                        >
                            <Chip sx={{
                                fontSize: "26px", top: 0, left: "50%",
                                transform: "translateX(-50%)",
                                position: "absolute",
                                maxHeight: "400px",
                                width: "400px",
                                maxWidth: "100%",
                                height: "100%",
                                "& .MuiChip-label": {
                                    fontWeight: "bold",
                                    color: "#292929",
                                    textAlign: "center",
                                    padding: "8px 16px",
                                    backgroundColor: "#DEE2E6",
                                    borderRadius: "12px",
                                    opacity: 0.7
                                },

                            }} label="สินค้าหมด" />
                        </Box>
                        {/* <Image
                            src={item?.image_url}
                            alt={`Image ${item?.sort + 1}`}
                            width={400}
                            height={400}
                            // priority
                            style={{
                                objectFit: "contain",
                                borderRadius: "12px",
                                maxHeight: "400px",
                                maxWidth: "100%",
                                height: "100%",
                                backgroundColor: "#fff",
                            }}
                            loading="lazy"
                            placeholder="empty"
                            blurDataURL={item?.image_url}
                        /> */}
                        <Image
                            src={item?.image_url}
                            alt={`Image ${item?.sort + 1}`}
                            width={400}
                            height={400}
                            loading="lazy"
                            style={{
                                objectFit: "contain",
                                borderRadius: "12px",
                                maxHeight: "400px",
                                maxWidth: "100%",
                                height: "100%",
                                backgroundColor: "#fff",
                            }}
                            placeholder="empty"
                            blurDataURL={item?.image_url}
                        />

                        {dataProduct.products.is_campaign === undefined ||
                            dataProduct.products.is_campaign == false ? (
                            ""
                        ) : (
                            <>
                                {campaign?.product && campaign?.product?.length > 0 && (
                                    <img
                                        src={`${ImgUrl?.imageCampaign}/uploads/campaign/${campaign?.id}/frame_product/${campaign?.frame_product}`}
                                        alt=""
                                        width="400px"
                                        height="400px"
                                        style={{

                                            zIndex: 9,

                                            maxHeight: "400px",
                                            maxWidth: "100%",
                                            height: "100%",
                                            borderRadius: "14px",
                                            display: "inline-block",

                                            transform: "translateY(-100%)"
                                        }}
                                    />
                                )}
                            </>
                        )}


                    </Box>





                </SwiperSlide>
            );
        } else if (item?.video_url) {
            return (
                <>
                    <SwiperSlide key={item.sort}>
                        <Box
                            display={
                                dataProduct.products.product_quantity === 0 &&
                                    dataProduct.products.product_stock === "0"
                                    ? "inline-flex"
                                    : "none"
                            }
                            sx={{
                                position: "absolute",
                                width: "100%",
                                height: "auto !important",
                                maxHeight: "400px",
                                zIndex: 99,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "14px"
                            }}
                        >
                            <Chip sx={{ fontSize: "26px" }} label="สินค้าหมด" />
                        </Box>
                        <div
                            id="player-overlay"
                            style={{
                                width: "100%",

                                backgroundImage: `url(${item?.image_url})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        >
                            <video
                                controls
                                playsInline
                                autoPlay
                                muted
                                ref={videoRef}
                                style={{
                                    width: "100%",
                                    height: "auto !important",
                                    maxHeight: "400px",
                                    objectFit: "contain"
                                }}
                            >
                                <source src={item?.video_url} />
                                <source
                                    src={item?.video_url}
                                    type='video/webm; codecs="vp8, vorbis"'
                                />
                                <source
                                    src={item?.video_url}
                                    type='video/ogg; codecs="theora, vorbis"'
                                />
                            </video>
                        </div>

                        {dataProduct.products.is_campaign === undefined ||
                            dataProduct.products.is_campaign == false ? (
                            ""
                        ) : (
                            <>
                                {campaign?.product && campaign?.product?.length > 0 && (
                                    <img
                                        src={`${ImgUrl?.imageCampaign}/uploads/campaign/${campaign?.id}/frame_product/${campaign?.frame_product}`}
                                        alt=""
                                        width="100%"
                                        height="100%"
                                        style={{
                                            position: "absolute",
                                            zIndex: 9,
                                            top: "20px",
                                            left: "0px",
                                            width: "100%",
                                            borderRadius: "14px"
                                        }}
                                    />
                                )}
                            </>
                        )}
                    </SwiperSlide>
                </>
            );
        }
        return null;
    };

    const formatPrice = (price: number, digits: number = 2): number => {
        const formattedPrice = parseFloat(price.toFixed(digits));
        return formattedPrice;
    };

    const updateDataLayer = (opt: any, itemList: { itemListId: string; itemListName: string }) => {
        // Check if dataProduct and products are defined
        if (!dataProduct || !dataProduct.products) {
            if (!isProduction) {
                console.warn("No product data available.");
            }
            return;
        }

        const productItem = (() => {
            const { products } = dataProduct;
            const productOptions = Array.isArray(products.product_option)
                ? products.product_option
                : [];

            if (productOptions.length > 0) {
                const productOption = (() => {
                    if (Array.isArray(opt.option_child) && opt.option_child.length > 0) {
                        return opt.option_child.map((child: any) => ({
                            discount:
                                child.option_discount > 0
                                    ? child.option_price - child.option_discount
                                    : 0,
                            price:
                                child.option_discount > 0
                                    ? child.option_discount
                                    : child.option_price,
                            item_variant: `${opt.option_title} - ${opt.option_name} / ${child.option_title} - ${child.option_name}`,
                            quatntity: 1,
                        }));
                    } else {
                        return [
                            {
                                discount:
                                    opt.option_discount > 0
                                        ? opt.option_price - opt.option_discount
                                        : 0,
                                price:
                                    opt.option_discount > 0
                                        ? opt.option_discount
                                        : opt.option_price,
                                item_variant: `${opt.option_title} - ${opt.option_name}`,
                                quantity: 1,
                            },
                        ];
                    }
                })();

                // Map product options to items
                return productOption.map((option: any) => ({
                    item_id: products.product_id || null,
                    item_name: products.product_title || null,
                    affiliation: null,
                    coupon: null,
                    discount: formatPrice(option.discount) || null,
                    index: 0,
                    item_brand: null,
                    item_category: null,
                    item_category2: null,
                    item_list_id: itemList.itemListId,
                    item_list_name: itemList.itemListName,
                    item_variant: option.item_variant || null,
                    location_id: null,
                    price: formatPrice(option.price) || null,
                    quantity: option.quantity || 1,
                }));
            } else {
                const isDiscounted = products.product_discounted_price > 0;
                const price = isDiscounted ? products.product_discounted_price : products.product_normal_price;
                const discount = isDiscounted ? products.product_normal_price - products.product_discounted_price : 0;

                return [
                    {
                        item_id: products.product_id || null,
                        item_name: products.product_title || null,
                        affiliation: null,
                        coupon: null,
                        discount:
                            formatPrice(discount),
                        index: 0,
                        item_brand: null,
                        item_category: null,
                        item_category2: null,
                        item_list_id: itemList.itemListId,
                        item_list_name: itemList.itemListName,
                        item_variant: null,
                        location_id: null,
                        price: formatPrice(price) || null,
                        quantity: 1,
                    },
                ];
            }
        })();

        // Calculate total value
        const totalValue = productItem.reduce((acc: number, item: any) => {
            const itemPrice = item.price || 0;
            const itemQuantity = item.quantity || 0;
            return acc + itemPrice * itemQuantity;
        }, 0);

        // Update the DataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null }); // Clear previous ecommerce data
        window.dataLayer.push({
            event: "view_item",
            ecommerce: {
                currency: "THB",
                value: formatPrice(totalValue),
                items: productItem,
            },
        });

        if (!isProduction) {
            console.log("DataLayer updated:", {
                event: "view_item",
                ecommerce: {
                    currency: "THB",
                    value: formatPrice(totalValue),
                    items: productItem,
                },
            });
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} alignItems="top">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={8} lg={9}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={2} lg={1}
                                        sx={{
                                            height: '100%',
                                            maxHeight: '400px',
                                            overflow: 'auto',
                                            scrollbarWidth: 'none',
                                            msOverflowStyle: 'none',
                                            '&::-webkit-scrollbar': {
                                                display: 'none',
                                            },
                                            // flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mt: 2,
                                            // flexDirection: {
                                            //     xs: 'column-reverse',  // Reverses the order when xs screen size
                                            //     sm: 'row'  // Default row direction for sm and up
                                            // }
                                            // gap: '10px',
                                            // my: 2
                                            order: { xs: 3, sm: 3, md: 1, lg: 1 }
                                        }}
                                    >
                                        {mixedArray && mixedArray.length > 0 ? (
                                            <>
                                                {mixedArray.map((item: any, i: number) => (
                                                    <Box
                                                        key={i}
                                                        sx={{
                                                            borderRadius: '14px',
                                                            cursor: 'pointer',
                                                            marginBottom: '10px',
                                                            display: {
                                                                xs: 'inline-block',
                                                                sm: 'inline-block',
                                                                md: 'inline-block',
                                                                lg: 'inline-block'
                                                            },
                                                            alignItems: 'top',
                                                            justifyContent: 'center',
                                                        }}
                                                        onClick={() => handleClickImage(i)}
                                                    >
                                                        {item?.image_url ? (
                                                            <Image
                                                                src={item?.image_url}
                                                                alt={`Image ${item?.sort + 1}`}
                                                                width={80}
                                                                height={80}
                                                                layout="fixed"
                                                                objectFit="cover"
                                                                style={{
                                                                    borderRadius: '14px', maxWidth: '80px', maxHeight: '80px',
                                                                    width: "100%", height: "100%",
                                                                    objectFit: 'cover',
                                                                }}
                                                                loading="lazy"
                                                                placeholder="empty"
                                                                blurDataURL={item?.image_url}
                                                            />
                                                        ) : (
                                                            <Box
                                                                sx={{
                                                                    backgroundImage: `url(${item?.image_url})`,
                                                                    backgroundSize: 'cover',
                                                                    backgroundPosition: 'center',
                                                                    borderRadius: '14px',
                                                                    position: 'relative',
                                                                }}
                                                            >
                                                                <Image
                                                                    src={`${ImgUrl.img_cdn_shop_image}logo/icon_play.jpg`}
                                                                    alt={`Image ${item?.sort + 1}`}
                                                                    width={80}
                                                                    height={80}
                                                                    layout="responsive"
                                                                    objectFit="contain"
                                                                    style={{
                                                                        borderRadius: '14px', maxWidth: '80px', maxHeight: '80px',
                                                                        width: "100%", height: "100%", objectFit: 'contain',
                                                                    }}
                                                                    loading="lazy"
                                                                    placeholder="empty"
                                                                    blurDataURL={`${ImgUrl.img_cdn_shop_image}logo/icon_play.jpg`}
                                                                />
                                                            </Box>
                                                        )}
                                                    </Box>
                                                ))}
                                            </>
                                        ) : null}
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={10} lg={4}
                                        sx={{
                                            height: '100%',
                                            maxHeight: '400px',
                                            // overflow: 'auto',
                                            scrollbarWidth: 'none',
                                            msOverflowStyle: 'none',
                                            '&::-webkit-scrollbar': {
                                                display: 'none',
                                            },
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mt: 2,
                                            order: { xs: 1, sm: 1, md: 2, lg: 2 } // Display first on xs, second on larger screens
                                        }}
                                    >
                                        {mixedArray && mixedArray.length > 0 ? (
                                            <>
                                                {mixedArray && mixedArray.length > 0 && renderSliderItem(mixedArray[selectedIndex])}
                                            </>
                                        ) : null}
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={7} sx={{ my: 2, order: { xs: 3, sm: 3 } }}>
                                        <Typography
                                            variant="h1"
                                            gutterBottom
                                            sx={{
                                                fontSize: "22px",
                                                fontFamily: "NotoSans-SemiBold, NotoSansThai-SemiBold !important",
                                            }}
                                        >
                                            {dataProduct?.products?.product_title}
                                        </Typography>
                                        {dataProduct?.products?.product_campaign_title === undefined ||
                                            dataProduct?.products?.product_campaign_title === null ? (
                                            ""
                                        ) : (
                                            <Box sx={{ textAlign: "justify", fontSize: "1rem" }}>
                                                {dataProduct?.products?.product_campaign_title}
                                            </Box>
                                        )}
                                        <Grid container spacing={2} sx={{ pl: "15px", pt: "12px" }}>
                                            <Grid xs={10} sm={8} md={8} lg={8}>
                                                <Box sx={{ display: "flex", alignItems: "center", my: 2 }}>
                                                    {dataProduct?.products.product_score > 0 && (
                                                        <>
                                                            <Rating
                                                                name="read-only"
                                                                value={dataProduct?.products.product_score}
                                                                precision={0.5}
                                                                readOnly
                                                                sx={{ mr: 1, fontSize: "14px" }}
                                                            />
                                                            <Typography
                                                                variant="body2"
                                                                component="div"
                                                                color="text.secondary"
                                                            >
                                                                <Box
                                                                    component="p"
                                                                    className="txt-bold black"
                                                                    sx={{ display: "inline", fontSize: "14px" }}
                                                                >
                                                                    {/* {parseFloat(dataProduct?.products.product_score).toFixed(1)} */}
                                                                    {dataProduct?.products.product_score}
                                                                </Box>
                                                            </Typography>
                                                        </>
                                                    )}

                                                    {dataProduct?.products.product_score > 0 && (
                                                        <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
                                                    )}
                                                    {dataProduct?.products.product_sold > 0 && (
                                                        <Typography variant="body2" component="div" color="text.secondary">
                                                            ขายแล้ว{" "}
                                                            <Box component="p" className="txt-bold black" sx={{ display: "inline" }}>
                                                                {dataProduct?.products.product_sold ? dataProduct.products.product_sold : "0"} ชิ้น
                                                            </Box>
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Grid>
                                            {/* <Grid xs={2} sm={4} md={4} lg={4}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "end",
                                                        mt: 1,
                                                    }}
                                                >
                                                    <ReportForm
                                                        token={getToken}
                                                        productId={dataProduct?.products.product_id}
                                                        productType={"Product"}
                                                    />
                                                </Box>
                                            </Grid> */}
                                            {dataProduct?.products?.product_in_campaign?.length != 0 && (
                                                <Grid lg={12} sx={{ py: 2, textAlign: "left" }}>
                                                    <CountDownTime 
                                                        campaign={campaign} 
                                                        alignmentXs="left" 
                                                        alignmentSm="left" 
                                                        alignmentMd="left" 
                                                        alignmentLg="left" 
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid container sx={{ padding: "0px" }}>
                                            <Grid container lg={12} alignItems="end">
                                                <Grid>
                                                    <Typography
                                                        variant="h4"
                                                        gutterBottom
                                                        color="secondary"
                                                        sx={{ fontFamily: ' NotoSans-SemiBold', mb: 0, mr: 1 }}
                                                    >
                                                        ฿{product?.product_option?.length !== 0 && optionChild == null ? (
                                                            priceRange === ""
                                                                ? formatNumber(discountPrice > 0 ? discountPrice : priceProduct)
                                                                : priceRange
                                                        ) : (
                                                            priceProduct === 0
                                                                ? priceRange
                                                                : formatNumber(discountPrice > 0 ? discountPrice : priceProduct)
                                                        ) || (
                                                            priceProduct != 0
                                                                ? formatNumber(priceProduct)
                                                                : null
                                                        )}
                                                    </Typography>
                                                </Grid>

                                                <Grid>
                                                    <Box
                                                        sx={{
                                                            typography: "body1",
                                                            display: "inline-block",
                                                            textDecoration: "line-through",
                                                            color: "#717275",
                                                            fontFamily: ' NotoSans-SemiBold'
                                                        }}
                                                    >
                                                        {fullPrice}
                                                    </Box>
                                                    <Box sx={{ ml: "5px", display: "inline-block", position: "relative", top: "-5px" }}>
                                                        {dataProduct?.products?.product_percentage_discount > 0 ? (
                                                            <Chip
                                                                color="error"
                                                                size="small"
                                                                label={`ส่วนลด  ${Math.trunc(dataProduct?.products?.product_percentage_discount)}%`}
                                                            />
                                                        ) : ("")}
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {isEmpty(campaignComingSoonDateTime) ? (
                                            <></>

                                        ) : (
                                            <>
                                                <Grid container>
                                                    <Stack spacing={0} direction={"row"} sx={{ textAlign: "center", justifyContent: "center", alignItems: "center", mt: "4px" }}>
                                                        {/* <Typography className="txt-bold txt-primary fontSize-12" sx={{ display: 'flex', alignItems: 'center' }}>
                                                            F
                                                            <FlashOnIcon fontSize="small" sx={{ position: 'relative', top: '2px', fontSize: "25px", margin: "0px -4px 0px -4px", width: "auto" }} />
                                                            ASH SALE :
                                                            
                                                        </Typography> */}
                                                        <Image
                                                            src={"/assets/images/icon/flashsale.png"}
                                                            alt='/assets/images/icon/flashsale.png'
                                                            width={100}
                                                            height={40}
                                                            style={{
                                                                position: 'relative', top: '2px', fontSize: "25px", margin: "0px -4px 0px -4px", width: "auto"
                                                            }}
                                                            loading="lazy"
                                                            placeholder="empty"
                                                            blurDataURL={"/assets/images/icon/flashsale.png"}
                                                        >

                                                        </Image>


                                                        <Typography className=' txt-secondary fontSize-12' sx={{ ml: "6px" }}>
                                                            จะเริ่มใน
                                                        </Typography>
                                                        <Typography className='txt-bold txt-secondary fontSize-12' sx={{ ml: "6px" }}>
                                                            {dayjs(campaignComingSoonDateTime).format("DD MMMM BBBB HH:mm")}
                                                        </Typography>

                                                    </Stack>
                                                </Grid>
                                            </>
                                        )}


                                        <Grid container spacing={2}
                                            sx={{
                                                pl: "20px",
                                                pt: "20px",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            {isEmpty(dataProduct?.coupon_in_product) ? (
                                                ""
                                            ) : (
                                                //   <StoreCoupon couponInProduct={dataProduct}></StoreCoupon>
                                                <></>
                                            )}

                                            <Grid container alignItems="flex-start">
                                                <Grid xs={2} md={2} lg={2}
                                                    display="flex"
                                                    justifyContent="start"
                                                    alignItems="center"
                                                    sx={{
                                                        mt: "14px"
                                                    }}
                                                >
                                                    <Typography variant="body2" color="text.secondary">
                                                        {firstOptionTitle}
                                                    </Typography>
                                                </Grid>
                                                <Grid xs={10} md={10}
                                                    display="inline-block"
                                                    justifyContent="start"
                                                    marginBottom="15px"
                                                >
                                                    <ToggleButtonGroup
                                                        color="primary"
                                                        value={productOption}
                                                        exclusive
                                                        onChange={handleChangeOption}
                                                        aria-label="Product Option"
                                                        sx={{
                                                            display: "inline-block",
                                                            "& .MuiToggleButtonGroup-grouped": {
                                                                border: "1px solid #DEE2E6",
                                                                "&:not(:first-of-type)": {
                                                                    borderLeft: "1px solid #DEE2E6",
                                                                    borderRadius: "4px",
                                                                    color: "#292929",
                                                                },
                                                                "&:first-of-type": {
                                                                    borderLeft: "1px solid #DEE2E6",
                                                                    borderRadius: "4px",
                                                                    color: "#292929",
                                                                },
                                                                "&.Mui-selected": {
                                                                    border: "1px solid #DB5A00",
                                                                    color: "#DB5A00"
                                                                },
                                                                "&:hover": {
                                                                    border: "1px solid #DB5A00",
                                                                },
                                                            },
                                                            "& .MuiToggleButton-root": {
                                                                "&:hover": {
                                                                    border: "1px solid #DB5A00",
                                                                    color: "#DB5A00",
                                                                    bgcolor: "#ffffff"
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        {product_option?.map((item: any) => {
                                                            let allOptionsZeroStock = false;
                                                            if (item.option_child.length > 0) {
                                                                allOptionsZeroStock = item.option_child.every(
                                                                    (option: any) => option.option_stock === 0
                                                                );
                                                            } else {
                                                                if (item.option_stock == 0) {
                                                                    allOptionsZeroStock = true;
                                                                }
                                                            }
                                                            return (
                                                                <ToggleButton
                                                                    key={item?.option_id}
                                                                    value={item?.option_id}
                                                                    aria-label={item?.option_name}
                                                                    sx={{
                                                                        mr: 2,
                                                                        mt: "15px",
                                                                        height: "30px",
                                                                        minWidth: "100px",
                                                                        color: `${allOptionsZeroStock === true && "#DEE2E6 !important"}`,
                                                                        border: `1 px solid ${allOptionsZeroStock === true && "#DEE2E6 !important"}`
                                                                    }}
                                                                    // #DEE2E6
                                                                    disabled={allOptionsZeroStock}
                                                                >
                                                                    {item?.option_name}
                                                                </ToggleButton>
                                                            );
                                                        })}
                                                    </ToggleButtonGroup>
                                                </Grid>
                                            </Grid>


                                            {isEmpty(firstOptionChildTitle) ? (
                                                ""
                                            ) : (
                                                <>
                                                    <Grid xs={2} md={2} lg={2}
                                                        display="flex"
                                                        justifyContent="start"
                                                        alignItems="center"
                                                        sx={{
                                                            mt: "14px"
                                                        }}
                                                    >
                                                        <Typography variant="body2" color="text.secondary">
                                                            {firstOptionChildTitle}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid xs={10} md={10} lg={10} display="flex" justifyContent="start">
                                                        <ToggleButtonGroup
                                                            color="primary"
                                                            value={optionChild}
                                                            exclusive
                                                            onChange={handleChangeOptionChild}
                                                            aria-label="Product Option"
                                                            sx={{
                                                                display: "inline-block",
                                                                "& .MuiToggleButtonGroup-grouped": {
                                                                    border: "1px solid #DEE2E6",
                                                                    "&:not(:first-of-type)": {
                                                                        borderLeft: "1px solid #DEE2E6",
                                                                        borderRadius: "4px",
                                                                        color: "#292929",
                                                                    },
                                                                    "&:first-of-type": {
                                                                        borderLeft: "1px solid #DEE2E6",
                                                                        borderRadius: "4px",
                                                                        color: "#292929",
                                                                    },
                                                                    "&.Mui-selected": {
                                                                        border: "1px solid #DB5A00",
                                                                        color: "#DB5A00"
                                                                    },
                                                                    "&:hover": {
                                                                        border: "1px solid #DB5A00",
                                                                    },
                                                                },
                                                                "& .MuiToggleButton-root": {
                                                                    "&:hover": {
                                                                        border: "1px solid #DB5A00",
                                                                        color: "#DB5A00",
                                                                        bgcolor: "#ffffff"
                                                                    },
                                                                },
                                                            }}
                                                        >    
                                                            {optionChildValue?.map((item: any) => {
                                                                return (
                                                                    <ToggleButton
                                                                        key={item?.option_id}
                                                                        color="primary"
                                                                        sx={{
                                                                            mr: 2,
                                                                            mt: "15px",
                                                                            height: "30px",
                                                                            minWidth: "100px",
                                                                            // opacity: item?.option_stock === 0 ? 0.5 : 1,
                                                                            // cursor: item?.option_stock === 0 ? "not-allowed" : "pointer"
                                                                            color: `${item?.option_stock === 0 && "#DEE2E6 !important"}`,
                                                                            border: `1 px solid ${item?.option_stock === 0 && "#DEE2E6 !important"}`
                                                                        }}
                                                                        value={item?.option_id}
                                                                        disabled={item?.option_stock === 0}
                                                                    >
                                                                        {item?.option_name}
                                                                    </ToggleButton>
                                                                );
                                                            })}
                                                        </ToggleButtonGroup>
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                        <Divider
                                            sx={{
                                                mt: "20px",
                                                mb: "20px"
                                            }}
                                        />
                                        <Grid container spacing={2}
                                            sx={{
                                                mt: "15px",
                                                ml: "5px"
                                            }}
                                        >
                                            <Grid xs={12} md={12}>
                                                <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    justifyContent="space-between"
                                                    alignItems="center"
                                                    sx={{
                                                        ".MuiSvgIcon-root": { fontSize: 24 },
                                                        ".MuiAvatar-root": { ml: 1, mb: 1 },
                                                    }}
                                                >

                                                   
                                                    <Box
                                                        display="inline-flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        gap={1} 
                                                    >
                                                        <Typography variant="body2" color="text.secondary" sx={{mb:"10px"}}>
                                                            แชร์ :
                                                        </Typography>
                                                        <Link href="">
                                                            <FacebookShareButton
                                                                url={currentUrl}
                                                                quote={dataProduct?.products?.product_title}
                                                            >
                                                                <Image
                                                                    src={"/assets/images/icon/Facebook_Logo_Primary 1.png"}
                                                                    width={32}
                                                                    height={32}
                                                                    alt=""
                                                                    loading="lazy"
                                                                    placeholder="empty"
                                                                    blurDataURL={"/assets/images/icon/Facebook_Logo_Primary 1.png"}
                                                                />
                                                            </FacebookShareButton>
                                                        </Link>
                                                        <Link href="">
                                                            <TwitterShareButton url={currentUrl}>
                                                                <Image
                                                                    src={"/assets/images/icon/xshare.png"}
                                                                    width={32}
                                                                    height={32}
                                                                    alt=""
                                                                    loading="lazy"
                                                                    placeholder="empty"
                                                                    blurDataURL={"/assets/images/icon/xshare.png"}
                                                                />
                                                            </TwitterShareButton>
                                                        </Link>
                                                    </Box>


                                                    <Box
                                                        sx={{
                                                            pr: "18px"
                                                        }}
                                                    >
                                                        <FavoriteButton
                                                            initialFavoriteCount={dataProduct?.products.favorite}
                                                            getToken={getToken}
                                                            productId={dataProduct?.products.product_id}
                                                            disableLabel={false}
                                                        />


                                                    </Box>

                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        {/* Section add to cart */}

                        {/* 
                            service_type 1 = "บริการแบบเลือกรายวัน"	
                            service_type 2 = "บริการแบบเลือกช่วงเวลา"
                            service_type 3 = "คอร์สเรียน"
                            service_type 4 = "บริการ walk-in"
                        */}

                            <Grid item xs={12} sm={12} md={4} lg={3} spacing={2}
                                sx={{
                                    my: 2,
                                    zIndex: 99,
                                    display: "inline-block",
                                    height: "fit-content"
                                }}
                                className={`floating-element ${isScrolledCard ? "scrolled" : ""}`}
                            >
                                <CardAddCard
                                    dataProduct={dataProduct}
                                    dataStoreInfo={dataStoreInfo}
                                    productOption={productOption}
                                    optionStork={optionStork}
                                    optionChildValue={optionChildValue}
                                    optionChild={optionChild}
                                />

                                
								{dataProduct?.products?.product_stock > 0 && dataProduct?.products?.service_type != "" && (
									<Box>
										<Divider textAlign="center" className="gray" sx={{ my: 2, fontSize: "12px" }}>บริการ</Divider>
										<DialogCheckDateService dataSet={dataProduct?.products}/>
									</Box>
                                )} 
                            </Grid>

                            <Grid item xs={12} sm={12} md={8} lg={9} sx={{ my: 2 }}>
                                <CardProfile
                                    data_info={dataStoreInfo}
                                    product_type={productType}
                                />
                                <ProductInfo
                                    dataSet={dataWaranty}
                                    dataDetail={dataProductDetail}
                                    dataSpecific={dataProductSpecific}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}